import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { PlataformaAssinaturaEletronicaComponent } from './plataforma-assinatura-eletronica.component';
import { CabecalhoEsquerdaModule } from '../../components/cabecalho/cabecalho-esquerda/cabecalho-esquerda.module';
import { BeneficioDireitaModule } from '../../components/beneficio/beneficio-direita/beneficio-direita.module';
import { BeneficioEsquerdaModule } from '../../components/beneficio/beneficio-esquerda/beneficio-esquerda.module';
import { FuncionamentoDireitaModule } from '../../components/funcionamento/funcionamento-direita/funcionamento-direita.module';
import { FuncionamentoEsquerdaModule } from '../../components/funcionamento/funcionamento-esquerda/funcionamento-esquerda.module';

@NgModule({
  declarations: [
    PlataformaAssinaturaEletronicaComponent
  ],
  imports: [
    TranslateModule,
    CommonModule,
    CabecalhoEsquerdaModule,
    FuncionamentoEsquerdaModule,
    FuncionamentoDireitaModule,
    BeneficioEsquerdaModule,
    BeneficioDireitaModule
  ],
  exports: [
    PlataformaAssinaturaEletronicaComponent
  ]
})

export class PlataformaAssinaturaEletronicaModule { }
